import { ClaimModalFormValues } from "@/features/my-order/features/order-history/features/claim/components/OrderHistoryClaimModal";
import {
  PostClaimDetail,
  PostClaimRequest,
} from "@/features/my-order/features/order-history/features/claim/types";

export const convertClaimFormToRequest = (
  form: ClaimModalFormValues
): PostClaimRequest => {
  const details: PostClaimDetail[] = form.items.flatMap((item) =>
    item.details.map((detail) => ({
      orderSheetProductOptionId: item.orderSheetProductOptionId,
      requestDetailType: detail.reasonCategory,
      requestDetailContent: detail.reasonDetail,
      unoFileIds: detail.unoFileIds,
    }))
  );

  return {
    requestType: "ORDER_CLAIM",
    requestContent: "",
    details,
  };
};
